import React, { useEffect, useState } from 'react';
import { graphql, useStaticQuery } from "gatsby";
import * as b from "../bootstrap.module.css";
import CashLoanContents from './content-column/cash-loan-contents';
import CashLoanProducts from './product-column/cash-loan-products';
import MortgageProducts from './product-column/mortgage-products';
import MortgageContents from './content-column/mortgage-contents';
import ConsolidationLoanContents from './content-column/consolidation-loan-contents';
import ConsolidationLoanProducts from './product-column/consolidation-loan-products';
import CarLoanProducts from './product-column/car-loan-products';
import CarLoanContents from './content-column/car-loan-contents';
import CreditPrimaryContents from './content-column/credit-primary-contents';
import CardProducts from './product-column/card-products';
import CardContents from './content-column/card-contents';
import Icon from "../icon.tsx";
import useMedia from '../../hooks/useMedia';
import CreditSecondaryContents from './content-column/credit-secondary-contents';

const CreditNavigation = ({ activeNavigation, changeNavigation }) => {
  const { categories } = useStaticQuery(graphql`
    query CreditTopNavigation {
      categories: allMysqlTerms(filter: {cluster: {in: ["credits_1", "credits_2", "credits_3", "credits_4", "cards"]}}) {
        nodes {
          term
          term_normalized
          path
          cluster
          menu_icon
        }
      }
    }
  `);

  const [activeTab, setActiveTab] = useState('');
  const isMobileResolution = useMedia(['(max-width: 992px)'], [true], false);

  const changeTab = (cluster) => setActiveTab(activeTab !== cluster ? cluster :  '');
  const previousStep = () => {
    if (activeTab) {
      setActiveTab('');
    } else if (activeNavigation) {
      changeNavigation('');
    }
  };

  useEffect(() => {
    if (activeNavigation !== 'credits') {
      setActiveTab('');
    }
  }, [activeNavigation]);

  if (!categories.nodes.length) {
    return null;
  }

  return (
    <div className={['top-navigation-tabs', 'active', activeNavigation !== 'credits' ? b.dNone : ''].join(' ')}>
      <div className="top-navigation-links">
        {isMobileResolution ? (<>
          <button onClick={previousStep} className="top-navigation-prev-step">
            <span className={[b.container, b.dFlex, b.alignItemsCenter].join(' ')}>
              <span className={b.pr1}>
                <Icon icon="Angle-left" size={24} color="#2B2B2B" />
              </span>

              <span>
                Cofnij do
                <strong>{activeTab ? 'kredytów' : 'menu głównego'}</strong>
              </span>
            </span>
          </button>

          {!activeTab && <strong className="top-navigation-title">Kredyty</strong>}

          <div className={b.pt1}>
            {categories.nodes.filter((category) => !activeTab || activeTab === category.cluster).map((category, i) => (
              <button 
                key={i} 
                onClick={() => changeTab(category.cluster)}
                className={["top-navigation-link", "top-navigation-link-arrow", activeTab === category.cluster ? 'active' : ''].join(' ')}
              >
                <span className="top-navigation-link-icon">
                  <Icon icon={category.menu_icon} size={34} />
                </span>

                {category.term}
              </button>
            ))}
          </div>
        </>) : (<>
          <strong className="top-navigation-title">Kredyty</strong>
        
          <div className={[b.mt2, b.pt1].join(' ')}>
            {categories.nodes.map((category, i) => (
              <button 
                key={i} 
                onClick={() => changeTab(category.cluster)}
                className={["top-navigation-link", "top-navigation-link-arrow", activeTab === category.cluster ? 'active' : ''].join(' ')}
              >
                <span className="top-navigation-link-icon">
                  <Icon icon={category.menu_icon} size={34} />
                </span>

                {category.term}
              </button>
            ))}
          </div>
        </>)}
      </div>
      
      <div className="top-navigation-products">
        {[['', CreditPrimaryContents], ['credits_1', MortgageProducts], ['credits_2', CashLoanProducts], ['credits_3', CarLoanProducts], ['credits_4', ConsolidationLoanProducts], ['cards', CardProducts]].map(([tab, Component], i) => (
          <div key={i} className={activeTab === tab ? '' : b.dNone}>
            <Component active={activeTab === tab} />
          </div>
        ))}
      </div>
      
      <div className="top-navigation-contents">
        {[['', CreditSecondaryContents], ['credits_1', MortgageContents], ['credits_2', CashLoanContents], ['credits_3', CarLoanContents], ['credits_4', ConsolidationLoanContents], ['cards', CardContents]].map(([tab, Component], i) => (
          <div key={i} className={activeTab === tab ? '' : b.dNone}>
            <Component active={activeTab === tab} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CreditNavigation;